import { AnySchema } from "yup";

export default function dedupeArray<T extends AnySchema>(this: T) {
  return this.transform(function (value, originalValue: string[]) {
    if (this.isType(value) && value !== null) {
      const seen = new Set<string>();

      // Dedupe case insensitively, but keep the original casing since some
      // sources (e.g. Scrolller) look tags up by their exact name.
      return originalValue.filter((v) => {
        if (!v || seen.has(v.toLowerCase())) {
          return false;
        }
        seen.add(v.toLowerCase());
        return true;
      });
    }
    return value;
  });
}
